// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fkkniwkbrwusabzbhqjl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZra25pd2ticnd1c2FiemJocWpsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA2Mjk3NDIsImV4cCI6MjA3NjIwNTc0Mn0.ZyTd4PmU1el3KDHttrRWSA1xK-ybPgk2rI17EPgG2Jg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});